import React from 'react';
import { FOOTER_LINKS } from '../data';
import styles from '../styles/Footer.module.css';

const Footer: React.FC = () => (
  <footer className={styles.footer} id="footer">
    <span className={styles.copy}>𓆝 𓆟 𓆞 𓆝 𓆟</span>
    <nav className={styles.social} aria-label="Social links">
      {FOOTER_LINKS.map(({ label, href, external }) => (
        <a
          key={label}
          href={href}
          className={styles.link}
          {...(external
            ? { target: '_blank', rel: 'noopener noreferrer' }
            : {})}
        >
          {label}
        </a>
      ))}
    </nav>
  </footer>
);

export default Footer;
